import Table from './table';
import Pagination from './pagination';

export { Table, Pagination };
